import * as joint from '@joint/plus';
import { clearSorterDataOnCopy } from '../utils/sanitize';
import { PAPER_ZOOM_SETTINGS } from './kitchensink/helpers/constants';

export class KeyboardService {
  constructor() {
    this.keyboard = new joint.ui.Keyboard();
  }

  create(graph, clipboard, selection, paperScroller, commandManager, inspectorService, readOnly = false) {
    if (!readOnly) {
      this.keyboard.on({
        'ctrl+c': () => {
          // Copy all selected elements and their associated links.
          clipboard.copyElements(selection.collection, graph);
        },
        'ctrl+v': () => {
          const pastedCells = clipboard.pasteCells(graph);
          const { elements } = clearSorterDataOnCopy(pastedCells);

          inspectorService.closeInspector();
          selection.collection.reset(elements); // Select newly created elements
        },
        'ctrl+x shift+delete': () => {
          clipboard.cutElements(selection.collection, graph);
        },
        'delete backspace': (evt) => {
          evt.preventDefault();
          graph.removeCells(selection.collection.toArray());
        },
        'ctrl+z': () => {
          commandManager.undo();
          selection.cancelSelection();
        },
        'ctrl+y': () => {
          commandManager.redo();
          selection.cancelSelection();
        },
        'ctrl+a': () => {
          selection.collection.reset(graph.getElements());
        },
        'ctrl+plus': (evt) => {
          evt.preventDefault();
          paperScroller.zoom(0.2, { max: PAPER_ZOOM_SETTINGS.max, grid: 0.2 });
        },
        'ctrl+minus': (evt) => {
          evt.preventDefault();
          paperScroller.zoom(-0.2, { min: PAPER_ZOOM_SETTINGS.min, grid: 0.2 });
        },
        'keydown:shift': (_evt) => {
          paperScroller.setCursor('crosshair');
        },
        'keyup:shift': () => {
          paperScroller.setCursor('grab');
        },
      });
    }
  }
}
